import { translate } from '../../../../Internationalization';

/**
 * @param {(header: string)=> string | JSX.Element} callback
 * @returns {({ title: string | JSX.Element })[]}
 */
export default function valuationTableHeader(callback) {
	return [
		'date',
		'address',
		'valuation',
		'name',
		'email',
		'phone',
		'mover_score',
		'added_to_contacts',
	].map((header) => {
		const title = translate(
			`agent.pages.widgets.lead_generation.lead_table.${header}`
		);

		if (header === 'mover_score') {
			return { title: callback(title) ?? title };
		}

		return { title };
	});
}
